"use client";

import { useSeparator } from "./A3CZKICO.js";
import { useCompositeContext } from "./P7GR5CS5.js";
import { createElement, createHook, forwardRef } from "./LMDWO4NN.js";
import { __objRest, __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/composite/composite-separator.tsx
import { invariant } from "@ariakit/core/utils/misc";
var TagName = "hr";
var useCompositeSeparator = createHook(function useCompositeSeparator2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useCompositeContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "CompositeSeparator must be wrapped in a Composite component.");
  var orientation = store.useState(function (state) {
    return state.orientation === "horizontal" ? "vertical" : "horizontal";
  });
  props = useSeparator(__spreadProps(__spreadValues({}, props), {
    orientation: orientation
  }));
  return props;
});
var CompositeSeparator = forwardRef(function CompositeSeparator2(props) {
  var htmlProps = useCompositeSeparator(props);
  return createElement(TagName, htmlProps);
});
export { useCompositeSeparator, CompositeSeparator };